export const SQ_PRIMARY = '#1cade4';
